import ApiService from '../api.service';
import { keysSnakeToCamel } from '../../utils/apiConvert';

const portal = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('portalToken')}` } });

export const portalDashboardService = {
  // → { employeesActive, documentsTotal }
  people: async () => keysSnakeToCamel((await ApiService.get('/api/portal/dashboard/people', portal()))?.data?.data || {}),

  // → [{ month: '2026-10', amount }] for the last 6 months, oldest first
  invoicedByMonth: async () => ((await ApiService.get('/api/portal/dashboard/invoiced-by-month', portal()))?.data?.data || [])
    .map((m) => ({ month: m.month, amount: Number(m.amount) || 0 })),
};
